import { createSlice } from "@reduxjs/toolkit";

const initialReservationState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  reservationForEdit: undefined,
  lastError: null,
  message: null,
  error: null,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const reservationSlice = createSlice({
  name: "reservations",
  initialState: initialReservationState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error.clientMessage;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      state.message = null;

      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    endCall: (state, action) => {
      state.error = null;
      state.message = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    // getReservationById
    reservationFetched: (state, action) => {
      state.actionsLoading = false;
      state.reservationForEdit = action.payload.reservationForEdit;
      state.error = null;
    },
    // getReservationChart
    reservationChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.reservationChart = action.payload.reservationChart;
      state.error = null;
    },
    // getReservationChart
    reservationHourlyChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.reservationChartHour = action.payload.reservationChartHour;
      state.error = null;
    },
    // getReservationChart
    reservationHourlyZoneChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.reservationChartHourZone = action.payload.reservationChartHourZone;
      state.error = null;
    },
    // get list data
    reservationsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.reservationForEdit = undefined;
      state.reservationChart = undefined;
      state.reservationChartHour = undefined;
      state.reservationChartHourZone = undefined;
    },
    // createReservation
    reservationCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.message = action.payload.msgResponse;
    },
    reservationStatusUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.message = action.payload.msgResponse;
    },
    // updateReservation
    reservationUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.message = action.payload.msgResponse;
      // Update state
      if (action.payload.reservationId) {
        state.entities = state.entities.map((item) => {
          if (item.id === action.payload.reservationId) {
            return { ...item, ...action.payload.reservation };
          } else {
            return item;
          }
        });
      }
    },
    // reservationDeleted
    reservationDeleted: (state, action) => {
      state.error = null;
      state.message = action.payload.msgResponse;
      state.actionsLoading = false;
    },
    setMessage: (state, action) => {
      state.error = null;
      state.message = action.payload.msgResponse;
    },
  },
});
